<template>
  <MainWrapper>
    <div class="companies-control-panel mb-30">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="companies-control-panel-inner">
              <router-link to="/user/companies" class="mr-20 header-link">
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                <span class="dark-body-text panel-body-text">Мои компании</span>
              </router-link>
              <router-link
                v-if="company.id !== 999999999"
                :to="`/companies/${$route.params.slug}/invite-specialist`"
                class="mr-20 header-link"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                <span class="dark-body-text panel-body-text">Пригласить специалиста</span>
              </router-link>
              <router-link
                v-if="company.id !== 999999999"
                :to="`/companies/${$route.params.slug}/settings`"
                class="mr-20 pointer header-link"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'cog']" />
                <span class="dark-body-text panel-body-text">Настройки</span>
              </router-link>
              <router-link
                v-if="company.id !== 999999999"
                :to="`/companies/${$route.params.slug}/reservations`"
                class="mr-20 header-link"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'calendar-check']" />
                <span class="dark-body-text panel-body-text">Все записи</span>
              </router-link>
              <div v-if="company.id !== 999999999" class="pointer pull-right">
                <router-link :to="`/companies/${$route.params.slug}/add-specialist`">
                  <span class="dark-body-text panel-body-text">Добавить</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="schedule-controls mb-20">
              <!--
                        <div class="button-left animated-shadow pointer round-button mr-10" @click="prevWeek">
                            <font-awesome-icon class="icon" :icon="['fal', 'angle-left']" />
                        </div>
                        <div class="button-right animated-shadow pointer round-button mr-30" @click="nextWeek">
                            <font-awesome-icon class="icon" :icon="['fal', 'angle-right']" />
                        </div>
              -->
              <div class="input-wrapper mr-15">
                <input v-model="startDay" class="rounded-input" type="date" />
              </div>
              <div class="input-wrapper mr-15">
                <input v-model="endDay" class="rounded-input" type="date" />
              </div>
              <!--
                        <div class="input-wrapper mr-15">
                            <select v-model="spec_slug" class="rounded-input">
                                <option v-for="spec, i in specialists" :key="i" :value="spec.slug">{{ spec.full_name }}</option>
                            </select>
                        </div>
              -->
              <div class="live-query-button-wrapper mr-15">
                <input v-model="client" class="rounded-input" type="text" placeholder="ФИО клиента" />
              </div>
              <!--
                        <div class="rounded-input mr-15" style="width:50px;padding-left:12.5px">
                            <font-awesome-icon v-if="live === true" class="icon " :icon="['fal', 'calendar-check']" style="display:inline-block;width:24px;height:24px;color:#2b2b2b" @click="live = !live" />
                            <font-awesome-icon v-if="live === false" class="icon " :icon="['fal', 'calendar-check']" style="display:inline-block;width:24px;height:24px;color:#dddddd" @click="live = !live" />
                        </div>
              -->
              <div class="rounded-input pointer mr-15" style="width:50px;padding-left:12.5px">
                <font-awesome-icon
                  v-if="live === true"
                  class="icon"
                  :icon="['fal', 'receipt']"
                  style="display:inline-block;width:24px;height:24px;color:#2b2b2b"
                  @click="live = !live"
                />
                <font-awesome-icon
                  v-if="live === false"
                  class="icon"
                  :icon="['fal', 'receipt']"
                  style="display:inline-block;width:24px;height:24px;color:#dddddd"
                  @click="live = !live"
                />
              </div>
              <div class="live-query-button-wrapper mr-15">
                <Button text="Применить" icon="check" @click="getReservations" />
              </div>
              <!--
                        <div class="live-query-button-wrapper">
                            <Button text="Живая очередь" @click="specModal = true; chosenDay = todayDay; live = true;" />
                        </div>
              -->
              <!--
                        <div class="live-query-button-wrapper mr-15">
                            <Button text="Напечатать" icon="print" />
                        </div>
              -->
              <!--
                        <div class="live-query-button-wrapper pull-right">
                            <input v-model="client" class="rounded-input" type="text" placeholder="Найти" />
                        </div>
              -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="white-panel">
              <div class="container-fluid">
                <div class="row mb-5 table-header">
                  <div class="col-lg-2 pt-20 pl-20 pr-20 pb-20">
                    Время записи
                    <!--<p class="desc mt-5">{ description }</p>-->
                  </div>
                  <div class="col-lg-3 pt-20 pl-20 pr-20 pb-20">
                    Клиент
                    <!--<p class="desc mt-5">{ description }</p>-->
                  </div>
                  <div class="col-lg-4 pt-20 pl-20 pr-20 pb-20">
                    Специалист
                    <!--<p class="desc mt-5">{ description }</p>-->
                  </div>
                  <div class="col-lg-2 pt-20 pl-20 pr-20 pb-20">
                    Тип записи
                    <!--<p class="desc mt-5">{ description }</p>-->
                  </div>
                </div>
                <div class="row" v-if="loading">
                  <div class="col-lg-12 loader">
                    <Loader />
                  </div>
                </div>
                <div v-else>
                  <div
                    v-if="orders.length > 0 && ord.master_name === company.name && ord.live === live"
                    class="row"
                    v-for="ord in orders"
                    :key="ord.id"
                  >
                    <!--div style="width:70px">
                                    <div class="mt-15 mb-15">
                                        <div class="single-filter">
                                            <div v-if="ord.status === 'confirmed'" class="filter-icon">
                                                <font-awesome-icon class="icon" :icon="['fal', 'calendar-check']" style="width:24px;height:24px;color:#27AE60" />
                                            </div>
                                            <div v-if="ord.status === 'armored'" class="filter-icon">
                                                <font-awesome-icon class="icon" :icon="['fal', 'calendar-plus']" style="width:24px;height:24px;color:#F2C94C" />
                                            </div>
                                            <div v-if="ord.status === 'success'" class="filter-icon">
                                                <font-awesome-icon class="icon" :icon="['fal', 'calendar-alt']" style="width:24px;height:24px;color:#2F80ED" />
                                            </div>
                                            <div v-if="ord.status === 'refused'" class="filter-icon">
                                                <font-awesome-icon class="icon" :icon="['fal', 'calendar-times']" style="width:24px;height:24px;color:#EB5757" />
                                            </div>
                                        </div>
                                    </div>
                    </div-->
                    <div class="col-lg-2">
                      <font-awesome-icon
                        v-if="ord.live === true"
                        class="icon"
                        :icon="['fal', 'receipt']"
                        style="display:inline-block;width:24px;height:24px;color:#c0c0c0"
                      />
                      <font-awesome-icon
                        v-if="ord.live === false && ord.status === 'confirmed'"
                        class="icon"
                        :icon="['fal', 'calendar-check']"
                        style="display:inline-block;width:24px;height:24px;color:#27AE60"
                      />
                      <font-awesome-icon
                        v-if="ord.live === false && ord.status === 'armored'"
                        class="icon"
                        :icon="['fal', 'calendar-plus']"
                        style="display:inline-block;width:24px;height:24px;color:#F2C94C"
                      />
                      <div class="ml-15 mt-15 mb-15" style="display:inline-block">
                        <span>Запись от</span>
                        <br />
                        <strong>{{ ord.created_at }}</strong>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="dark-body-text mt-15">{{ ord.client_name }}, {{ ord.phone }}</div>
                      <div class="mb-15">{{ ord.service }}</div>
                    </div>
                    <div class="col-lg-4">
                      <router-link
                        :to="'/companies/'+$route.params.slug+'/admin/specialists/'+ord.slug"
                      >
                        <font-awesome-icon
                          class="icon"
                          :icon="['fal', 'calendar-alt']"
                          style="display:inline-block;width:24px;height:24px;color:#24ceda"
                        />
                      </router-link>
                      <div class="ml-15 mt-15 mb-15" style="display:inline-block">
                        <div>На прием к</div>
                        <div class="dark-body-text">{{ ord.full_name }}</div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="mt-15 mb-15">
                        <span v-if="ord.live === true">Живая очередь</span>
                        <span v-else>По записи</span>
                        <br />
                        <span>
                          на
                          <strong>{{ ord.date_time_reservation }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-1">
                      <div class="mt-15 mb-15">
                        <div class="single-filter pull-right">
                          <div class="filter-icon pointer">
                            <font-awesome-icon
                              class="mr-10 admin-order-change-icons-single"
                              :icon="['fal', 'print']"
                              @click="printPopup(ord)"
                              style="width:24px;height:24px"
                            />
                          </div>
                          <div v-if="ord.status === 'armored'" class="filter-icon pointer">
                            <font-awesome-icon
                              class="mr-10 admin-order-change-icons-single"
                              :icon="['fal', 'check-circle']"
                              @click="updateStatus(ord.id, 'confirmed')"
                              style="cursor:pointer;width:24px;height:24px;color:#27AE60"
                            />
                          </div>
                          <div class="filter-icon pointer">
                            <font-awesome-icon
                              class="mr-10 admin-order-change-icons-single"
                              :icon="['fal', 'times-circle']"
                              @click="confirmCanseledPopup(ord.id, ord.service, ord.client_name)"
                              style="width:24px;height:24px;color:#EB5757"
                            />
                          </div>
                          <!--
                                            <span v-if="ord.status === 'armored'">Забронировано</span>
                                            <span v-if="ord.status === 'confirmed'">Подтвержден</span>
                                            <span v-if="ord.status === 'success'">Выполнено</span>
                                            <span v-if="ord.status === 'refused'">Отказано</span>
                          -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!loading && orders.length === 0" class="row">
                  <div class="col-lg-12">
                    <p class="mt-15 mb-15" style="text-align:center">Нет данных</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RegisterTimeModal
      :date="chosenDay"
      :opened="specModal"
      v-on:reservation-created="reservationCreatedHandler"
      v-on:close-it="specModal = false"
      :org="chosenCompany"
      :specialist="this.specialist"
      :services="this.services"
      v-on:choose-sect="(i) => this.chosenService = i"
      :periods="this.periods"
      :live="this.live"
      :registrator="false"
    ></RegisterTimeModal>
    <div
      v-if="printForm == true"
      style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99"
    >
      <div
        style="position:absolute;width:320px;height:320px;top:50%;left:50%;background:#ffffff;margin:-160px 0 0 -160px;padding:20px;box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);border-radius: 4px;text-align: center"
      >
        <div id="printElement">
          <p class="mb-15" style="text-align:center">
            <img src="/images/logo_black.svg" style="width:125px" />
          </p>
          <p
            class="dark-body-text"
            style="font-family: 'Arial Black';
    line-height: normal;
    font-size: 10px;
    text-align: center;
    color: #000000;"
          >{{ company.name }}</p>
          <p
            class="dark-body-text"
            style="font-family: 'Arial Black';
    line-height: normal;
    font-size: 16px;
    text-align: center;
    color: #000000;"
          >{{ printData.master_name }}</p>
          <h1
            style="font-family:'Arial Black';font-size:33px;color:#000"
          >{{ printData.time_reservation }}</h1>
          <p
            class="dark-body-text mb-10"
            style="font-family: 'Arial Black';
    line-height: normal;
    font-size: 10px;
    text-align: center;
    color: #000000;"
          >{{ printData.date_time_reservation }}</p>
          <p
            class="dark-body-text"
            style="font-family: 'Arial Black';
    line-height: normal;
    font-size: 10px;
    text-align: center;
    color: #000000;"
          >{{ printData.service }}</p>
          <p
            class="dark-body-text mb-15"
            style="font-family: 'Arial Black';
                line-height: normal;
                font-size: 10px;
                text-align: center;
                color: #000000;"
          >{{ printData.price }} cом</p>
          <p
            class="mb-5"
            style="font-family: 'Arial Black';
    line-height: normal;
    font-size: 10px;
    text-align: center;
    color: #000000;"
          >Клиент: {{ printData.client_name }}</p>
        </div>
        <div class="mt-30">
          <div class="mr-10 inline-block">
            <Button type="blue" text="Печать" @click="PrintMe('printElement')" />
          </div>
          <div class="inline-block">
            <Button type="gray" text="Отмена" @click="printForm = false" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="confirmCanseled == true"
      style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99"
    >
      <div
        style="position:absolute;width:320px;height:400px;top:100px;left:50%;background:#ffffff;margin:0 0 0 -160px;padding:20px;box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);border-radius: 4px;"
      >
        <h3 class="mb-10">Отмена заявки #{{ confirmCanseledData.id }}</h3>
        <p class="mb-5">Услуга</p>
        <p class="dark-body-text mb-15">{{ confirmCanseledData.service }}</p>
        <p class="mb-5">Клиент</p>
        <p class="dark-body-text mb-30">{{ confirmCanseledData.client_name }}</p>
        <p class="mb-15">Укажите причину отмены заявки</p>
        <textarea
          v-model="confirmCanseledData.comment"
          style="width:100%;height:100px"
          class="mb-15"
        ></textarea>
        <div>
          <div class="mr-10 inline-block">
            <Button type="blue" text="Подтвердить" @click="canceledOrder(confirmCanseledData.id)" />
          </div>
          <div class="inline-block">
            <Button type="gray" text="Отмена" @click="confirmCanseled = false" />
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
/* @import '../styles/main.core.vars.styl'; */
.single-filter {
  display: inline-flex;
  align-items: center;

  .filter-icon {
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
  }
}

.table-header {
  background: radial-gradient(722.67px at 77.85% 86.89%, #1BEFDC 0%, #24CEDA 100%);
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
}

.white-panel {
  overflow: hidden;
}

.desc {
  font-weight: 400;
  text-transform: none;
}

.spec-categories {
  padding: 20px 60px 30px 20px;
}

.spec-categories-header {
  display: flex;

  .spec-count {
    margin: 0 0 0 auto;
    color: $gray_text;
  }
}

.spec-categories-single {
  display: flex;
  align-items: center;

  >.icon {
    margin-left: auto;
    font-size: 16px;
  }
}

.companies-control-panel {
  margin-top: -30px;
  height: 56px;
  background: $black_text;

  .panel-body-text, .panel-icon {
    color: #fff;
  }

  .panel-icon {
    font-size: 16px;
  }

  &-inner {
    height: 56px;
    display: flex;
    align-items: center;

    >div {
      display: flex;
      align-items: center;
    }
  }

  input {
    width: 430px;
  }
}

.col-lg-1 {
  min-height: 0;
}

.arr-down {
  position: absolute;
  bottom: -2px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid $black_text;
  z-index: 4;
  left: 0;
  right: 0;
  margin: auto;
}

.schedule-controls {
  display: flex;
  align-items: center;
}
</style>
<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import Specialist from "@/components/Specialist.vue";
import Paginator from "@/components/Paginator.vue";
//import ScheduleAdmin from '@/components/ScheduleAdmin.vue';
import RegisterTimeModal from "@/components/modals/RegisterTimeModal.vue";

import moment from "moment";

import http from "@/methods/http.ts";

@Component({
  components: {
    MainWrapper,
    Button,
    Loader,
    Specialist,
    Paginator,
    //ScheduleAdmin,
    RegisterTimeModal
  }
})
export default class CompanyAdmin extends Vue {
  moment = moment;
  todayDay = moment().format("DD.MM.YYYY");
  specModal = false;
  chosenCompany = {
    owner: ""
  };
  chosenDay = moment().format("DD.MM.YYYY");

  live = false;

  client = "";

  cutBuffer = false;
  copyBuffer = false;

  specialists = [];
  spec_slug = "";

  specialist_slug = "";

  specialist = {};
  services = {};
  periods = [];

  specInfo = {
    rating: 0,
    categories: []
  };

  orders = [];

  zcolors = [];
  colors = ["#2F80ED", "#F2C94C", "#ddd", "#eee"];

  company = {
    id: 999999999
  };

  printForm = false;
  confirmCanseled = false;

  confirmCanseledData = {
    id: "",
    service: "",
    client_name: "",
    comment: ""
  };

  printData = {
    id: "",
    service: "",
    price: "",
    client_name: "",
    date_time_reservation: "",
    time_reservation: "",
    master_name: ""
  };

  startDay = moment()
    .subtract(2, "day")
    .format("YYYY-MM-DD");
  endDay = moment()
    .add(1, "day")
    .format("YYYY-MM-DD");

  loading = true

  cancelBuffer() {
    if (this.cutBuffer === true) {
      this.cutBuffer = false;
      this.$refs.calendar.cutBuffer = false;
    }
    if (this.copyBuffer === true) {
      this.copyBuffer = false;
      this.$refs.calendar.copyBuffer = false;
    }
  }

  nextWeek() {
    this.$refs.calendar.ordersFillData = [];
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .add(7, "d")
      .format("DD.MM.YYYY");

    let myDate = this.firstDay;
    myDate = myDate.split(".");
    this.teleportDay = myDate[2] + "-" + myDate[1] + "-" + myDate[0];
  }

  prevWeek() {
    /*
            var myDate = this.firstDay;
            myDate = myDate.split(".");
            var newDate = myDate[1]+"/"+myDate[0]+"/"+myDate[2];
            var stepDay = Math.floor(new Date(newDate).getTime() / 1000);
            myDate = moment().format("DD.MM.YYYY");
            myDate = myDate.split(".");
            var newDate = myDate[1]+"/"+myDate[0]+"/"+myDate[2];
            var todayDay = Math.floor(new Date(newDate).getTime() / 1000);

            if (stepDay <= todayDay) {
                return false;
            }
            */
    this.$refs.calendar.ordersFillData = [];
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .subtract(7, "d")
      .format("DD.MM.YYYY");

    let myDate = this.firstDay;
    myDate = myDate.split(".");
    this.teleportDay = myDate[2] + "-" + myDate[1] + "-" + myDate[0];
  }

  teleportSetTime() {
    var myDate = this.teleportDay.split("-");
    this.$refs.calendar.ordersFillData = [];
    this.firstDay = myDate[2] + "." + myDate[1] + "." + myDate[0];
  }

  confirmCanseledPopup(id, service, client_name) {
    this.confirmCanseledData.id = id;
    this.confirmCanseledData.service = service;
    this.confirmCanseledData.client_name = client_name;
    this.confirmCanseledData.comment = "";
    this.confirmCanseled = true;
  }

  canceledOrder(id) {
    if (this.confirmCanseledData.comment === "") {
      this.$store.commit("notificate", {
        type: "alert",
        text: "Укажите причину отмены заявки"
      });
      return false;
    }
    this.updateStatus(id, "refused");
  }

  printPopup({
    id,
    service,
    price,
    client_name,
    date_time_reservation,
    full_name: master_name
  }) {
    console.group("PRINT_POPUP");
    console.log({
      id,
      service,
      price,
      client_name,
      date_time_reservation,
      master_name
    });
    console.groupEnd();
    moment.lang("ru");
    let time_reservation = moment(
      date_time_reservation,
      "DD.MM.YYYY HH:mm"
    ).format("HH:mm");
    date_time_reservation = moment(
      date_time_reservation,
      "DD.MM.YYYY HH:mm"
    ).format("DD MMMM YYYY");
    this.printData.service = service;
    this.printData.price = price;
    this.printData.client_name = client_name;
    this.printData.date_time_reservation = date_time_reservation;
    this.printData.time_reservation = time_reservation;
    this.printData.master_name = master_name;
    this.printForm = true;
  }

  PrintMe(elm) {
    var disp_setting = "toolbar=yes,location=no,";
    disp_setting += "directories=yes,menubar=yes,";
    disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
    var content_vlue = document.getElementById(elm).innerHTML;
    var docprint = window.open("", "", disp_setting);
    docprint.document.open();
    docprint.document.write(
      '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
    );
    docprint.document.write(
      '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
    );
    docprint.document.write(
      '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
    );
    docprint.document.write("<head><title>My Title</title>");
    docprint.document.write('<style type="text/css">body{ margin:0px;');
    docprint.document.write("font-family:verdana,Arial;color:#000;");
    docprint.document.write(
      "font-family:Verdana, Geneva, sans-serif; font-size:12px;}"
    );
    docprint.document.write("a{color:#000;text-decoration:none;} </style>");
    docprint.document.write('</head><body onLoad="self.print()"><center>');
    docprint.document.write(content_vlue);
    docprint.document.write("</center></body></html>");
    docprint.document.close();
    docprint.focus();
  }

  getSpecInfo() {
    http(`masters/${this.specialist_slug}`, "get", false, {}).then(r => {
      this.specialist = r.data;
      this.services = r.data.service;
      this.chosenCompany.owner = "";
      this.specInfo = r.data;
      let owner_colors = [];
      let color_palette = this.colors;
      let i = 0;
      if (this.specInfo.company) {
        this.specInfo.company.forEach(function(element) {
          owner_colors[element.owner] = color_palette[i];
          i++;
        });
        this.zcolors = owner_colors;
      }
    });
  }

  getUserInfo() {
    http("user/info", "get", this.$store.state.token, {}).then(r => {
      this.specialist_slug = r.data.specialist_slug;
      this.getSpecInfo();
      this.getSpecReservations();
    });
  }

  getSpecReservations() {
    let url = "masters/" + this.specialist_slug + "/reservations";
    let from = this.startDay.split("-");
    let to = this.endDay.split("-");
    http(url, "get", this.$store.state.token, {
      status: this.status,
      sort: "reservation_time_desc",
      from: from[2] + "." + from[1] + "." + from[0],
      to: to[2] + "." + to[1] + "." + to[0],
      live: true
    }).then(r => {
      console.group("getSpecReservations");
      console.log(r.data);
      console.groupEnd();
      this.orders = r.data;
      /*
                if (r.data.length > 0) {
                    let index, s_time, e_time, subindex;
                    moment.lang('ru');
                    r.data.forEach(function(element) {
                        index  = moment(element.date_time_reservation, 'DD.MM.YYYY HH:mm').format('DD MMMM YYYY');
                        s_time = moment(element.date_time_reservation, 'DD.MM.YYYY HH:mm').format('HH:mm');
                        e_time = moment(element.duration, 'HH:mm:ss').format('HH:mm');
                        e_time = moment(e_time, 'HH:mm').diff(moment().startOf('day'), 'seconds');
                        e_time = moment(element.date_time_reservation, 'DD.MM.YYYY HH:mm').add(e_time, 'seconds').format('HH:mm');
                        subindex = element.id;
                        info = {
                            'id': element.id,
                            'date': index,
                            'time': s_time + ' - ' + e_time,
                            'name': element.client_name,
                            'service': element.service,
                            'address': element.street_address,
                            'comment': element.comment,
                            'status': element.status
                        };
                        if (item_list[index]) {
                            item_list[index][subindex] = info;
                        } else {
                            item_list[index] = {[subindex]: info};
                        }
                    });
                }
                this.itemlist = item_list;
                this.itemlist_count = r.data.length;
                */
    });
  }

  reservationCreatedHandler() {
    this.getSpecReservations();
  }

  updateStatus(id, status) {
    http("reservation/update", "post", this.$store.state.token, {
      id: id,
      status: status,
      comment: this.confirmCanseledData.comment
    }).then(
      r => {
        if (r.data.success === true) {
          this.confirmCanseled = false;
          this.$store.commit("notificate", {
            type: "action",
            text: "Запись обновлена"
          });
          this.getReservations();
        }
      },
      error => {
        this.$store.commit("notificate", {
          type: "alert",
          text: error.response.data.message
        });
      }
    );
  }

  getReservations() {
    let url = "companies/" + this.$route.params.slug + "/reservations";
    let from = this.startDay.split("-");
    let to = this.endDay.split("-");
    http(url, "get", false, {
      status: this.status,
      sort: "reservation_time_desc",
      from: from[2] + "." + from[1] + "." + from[0],
      to: to[2] + "." + to[1] + "." + to[0],
      client: this.client,
      live: true
    }).then(r => {
      console.group("getReservations");
      console.log(r.data);
      console.groupEnd();
      this.orders = r.data;
      this.orders.sort((order1, order2) => moment(order1.created_at, 'DD.MM.YYYY HH:mm').unix() < moment(order2.created_at, 'DD.MM.YYYY HH:mm').unix() ? 1 : -1)
      this.loading = false
    });
  }

  getCompany() {
    http(`companies/${this.$route.params.slug}`, "get", false, {}).then(r => {
      if (r.data.id > 0) {
        this.company = r.data;
        this.getReservations();
        this.getSpecialists();
      }
    });
  }

  getSpecialists() {
    http("masters", "get", false, {
      page: this.page,
      org_id: this.company.id,
      page_size: 12,
      search: this.search
      //categories: this.chosenChildCategory || this.chosenCategory || undefined,
    }).then(r => {
      this.specialists = r.data.results;
      this.pages = Math.ceil(r.data.count / 10);
      this.specCount = r.data.count;
    });
  }

  created() {
    this.getCompany();
  }
}
</script>